import { z } from 'zod';

import { emojiSchema } from './utils.ts';

const baseEmojiReactionSchema = z.object({
  count: z.number().nullable().catch(null),
  me: z.boolean().catch(false),
  name: emojiSchema,
  url: z.literal(undefined).catch(undefined),
});

const customEmojiReactionSchema = baseEmojiReactionSchema.extend({
  name: z.string(),
  /** Akkoma custom emoji reaction. */
  url: z.string().url(),
});

/**
 * kmyblue (and similar Mastodon forks) custom emoji reaction: the name is
 * a shortcode rather than a unicode character, and remote reactions carry
 * a domain, image dimensions, and the list of accounts that reacted.
 */
const kmyblueEmojiReactionSchema = baseEmojiReactionSchema.extend({
  name: z.string(),
  url: z.string().url().optional().catch(undefined),
  static_url: z.string().url().optional().catch(undefined),
  domain: z.string().optional().catch(undefined),
  width: z.number().optional().catch(undefined),
  height: z.number().optional().catch(undefined),
  account_ids: z.array(z.string()).optional().catch(undefined),
});

/** Pleroma emoji reaction. */
const emojiReactionSchema = baseEmojiReactionSchema
  .or(customEmojiReactionSchema)
  .or(kmyblueEmojiReactionSchema);

type EmojiReaction = z.infer<typeof emojiReactionSchema>;

export { emojiReactionSchema, type EmojiReaction };